import React from "react";
import "./GirlsBranch.css";

function GirlsBranch() {
  return (
    <div className="girls-branch-containers">
      {/* Header Section */}
      <header className="branch-header">
        <h1>Girls Branch</h1>
        <p>
          Welcome to the Girls Branch campus. We are dedicated to nurturing
          academic excellence and holistic development for our students.
        </p>
      </header>

      {/* Campus Info Section */}
      <section className="branch-info">
        <h2>About Our Branch</h2>
        <p>
          Our Girls Branch is designed with modern classrooms, advanced
          laboratories, sports facilities, and a highly qualified faculty.
          We emphasize discipline, learning, and extracurricular activities
          to build strong future leaders.
        </p>
      </section>

      {/* Facilities Section */}
      <section className="branch-facilities">
        <h2>Facilities</h2>
        <ul>
          <li>Smart Classrooms</li>
          <li>Science & Computer Labs</li>
          <li>Library</li>
          <li>Play Area & Sports Ground</li>
          <li>Safe Transport Service</li>
        </ul>
      </section>

      {/* Contact Details */}
      <section className="branch-contact">
        <h2>Contact Information</h2>
        <p>
          <strong>Address:</strong> 5F98+VHC, Naveed Town, Multan, Pakistan
        </p>
        <p>
          <strong>Phone:</strong> +92 302 6854636
        </p>
        <p>
          <strong>Email:</strong> academicgroupofschools@gmail.com
        </p>
      </section>

      {/* Google Map Embed */}
      <section className="branch-map">
        <h2>Find Us on Map</h2>
        <div className="map-container">
          <iframe
            title="Girls Branch Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3401.3671270567776!2d71.4637997!3d30.1696937!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x393b33d2d9477c2b%3A0x6d91a4c6e2a1c1ab!2s5F98%2BVHC%20Multan!5e0!3m2!1sen!2s!4v1695400000000!5m2!1sen!2s"
            width="100%"
            height="350"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
        <a
          href="https://www.google.com/maps/place/5F98%2BVHC+Multan"
          target="_blank"
          rel="noopener noreferrer"
          className="directions-btn"
        >
          📍 Get Directions
        </a>
      </section>
    </div>
  );
}

export default GirlsBranch;
